import { render, staticRenderFns } from "./MySubscriptions.vue?vue&type=template&id=17951d7a"
import script from "./MySubscriptions.vue?vue&type=script&lang=js"
export * from "./MySubscriptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports